import { render } from "./CampaignOverview.vue?vue&type=template&id=f348dd6e&ts=true"
import script from "./CampaignOverview.vue?vue&type=script&lang=ts"
export * from "./CampaignOverview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__